"use client";

import React from "react";
import { LogOut } from "lucide-react";
import { DropdownMenuItem } from "../../dropdown-menu";

interface SignOutItemProps {
  onSignOut: () => void | Promise<void>;
}

export function SignOutItem({ onSignOut }: SignOutItemProps) {
  return (
    <DropdownMenuItem
      onClick={onSignOut}
      className="flex items-center px-3 py-2 cursor-pointer text-red-600 focus:text-red-600 focus:bg-red-50 dark:text-red-400 dark:focus:text-red-400 dark:focus:bg-red-950/40"
    >
      <LogOut className="mr-3 h-4 w-4" />
      <div>
        <div className="font-medium">Sign Out</div>
        <div className="text-xs text-red-500">End your session</div>
      </div>
    </DropdownMenuItem>
  );
}
